<script setup lang="ts">

import AccountTinyCard from '@/onenetwork/components/account_card/AccountTinyCard.vue'

interface Props {
  data: object | string | number,
  cellConfig: Object,
  tableConfig?: Object,
}

const props = defineProps<Props>()

</script>

<template>
  <div class="table-cell account-cell">
    <template v-if="props.data">
      <account-tiny-card :data="props.data" :cell-config="props.cellConfig"/>
    </template>
      <template v-else>
        <span>--</span>
      </template>
  </div>
</template>

<style scoped>

</style>
